import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import moment from "moment";

interface EventFormData {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  name: string;
  code: string;
};

const AddCountry = ({ show, handleClose, data }: EventFormData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm<FormData>();
  const [value, setValue] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  // ✅ Dropdown options with different id and label

  useEffect(() => {
    if (data) {
      reset({
        name: data.name || "",
        code: data.code || "",
      });
    } else {
      reset({});
      setValue("");
    }
  }, [show]);

  const onSubmit = (request: FormData) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("name", request.name);
    formData.append("code", request.code);

    if (data?._id) {
      WebService.fileUploadPutAPI({
        action: `country/edit/${data._id}`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    } else {
      WebService.fileUploadAPI({
        action: `country/add`,
        body: formData,
      })
        .then((res: any) => {
          toast.success(res.message);
          reset();
          handleClose();
          setFile(null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          reset();
          setFile(null);
          handleClose();
        }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {data ? "Edit Country" : "Add Country"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && (
                <div className="error-message">{errors.name.message}</div>
              )}
            </Form.Group>
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Code <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Code"
                {...register("code", { required: "Code is required" })}
              />
              {errors.code && (
                <div className="error-message">{errors.code.message}</div>
              )}
            </Form.Group>

          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddCountry;
